<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        01.24
        <br />2019
      </span>
      <span class="tiel">美菜开启“公益宝贝”模式，精准扶贫不掉线</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        近日，美菜网在美菜APP上开启“公益宝贝”项目，目的是想借助美菜网互联网平台，聚集互联网上的力量，想要为弱势群体提供一定的帮扶服务。实际上美菜公益宝贝计划是由中国红十字基金会最美菜公益基金发起的项目，这个项目不仅能帮助农民卖出农产品，从源头上解决问题，而且从侧面关注留守儿童的心理状况，帮助他们健康成长。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a012_1.png" width="300" />
      </p>
      <div class="tet-js" style="text-align: center">美菜公益宝贝海报</div>
      <!-- <div class="title-bold"><span></span>20年里的朴实无华</div> -->
      <div class="tet-js">
        今后打开美菜APP，你可以看见部分商品下面带有"公益宝贝"字样的绿色标签。据悉，美菜爱心供应商积极响应公益扶贫的号召，自愿把部分在售商品设置成"公益宝贝"。商户购买带有"公益宝贝"标志的商品后，供应商将捐赠一定金额给最美菜公益基金，用于执行"最美教室"等公益项目。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a012_2.jpeg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">美菜网公益宝贝现场</div>
      <div class="tet-js">
        比如，美菜APP上每卖出一件中粮名庄荟商品捐献0.5元、每卖出一件丰收葡萄酒捐献0.5元、北京地区每卖出一件"牛栏山"产品捐献0.5元……短短三天时间内，包括益海嘉里食品营销有限公司、中粮名庄荟国际酒业有限公司、北京丰收酒业葡萄酒有限公司、北京顺通鑫源商贸有限公司、盘锦益仁生态农业发展有限公司和四川鑫樽中恒商贸有限公司等在内的100多家供应商携带4000多个单品纷纷报名参与该计划。这意味着，你的每次购买都在为寒门学子捐献爱心，买买买也是做公益。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a012_3.jpeg" width="400" />
      </p>
      <div class="tet-js" style="text-align: center">美菜APP公益宝贝栏目</div>
      <div class="tet-js">
        "做公益是好事，也是企业家应该承担的社会责任，我们积极报名！"四川鑫樽中恒商贸有限公司总经理彭宇是第一个报名参加的美菜爱心供应商，去年11月他跟着最美菜公益基金志愿者们来到国家贫困地区广西红岩捐赠"最美教室"。几十里的山路，大家泥泞中负重前行，给山区孩子带去了爱心物资和心灵温暖。"山区的孩子们太苦了，社会应该多关注他们。我们平时想做公益却缺乏专业的途径，现在最美菜公益基金给我们搭建了很好的公益平台！"
        <br />
        <br />据了解，最美菜公益基金是由美菜网和中国红十字基金会共同发起，旨在关注农产品供应链上的弱势群体，关注他们的生命安全与生计发展。目前，最美菜公益基金已经开展"小候鸟关爱计划""最美教室""最美菜扶贫公开课"等相关项目，为农村留守儿童送去温暖。此外，美菜还在全国各地实施美菜SOS精准扶贫全国采购计划，为陷入绝望的滞销菜农带去希望。
        <br />
        <br />美菜初生之时，就带有公益扶贫色彩。美菜CEO刘传军创办美菜旨在借助互联网的力量，尽可能地改变农村的现状、改善农民的生活，进而推动新时代农业的发展。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/a012_4.jpeg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">美菜公益宝贝展示</div>
      <div class="tet-js">
        "美菜希望与合作伙伴共同探索出一条商业可持续的精准扶贫之路！"这句话就是美菜网想要精准扶贫的信心，对于公益宝贝项目，美菜网也是投入了很多心血，相信借助美菜网APP，可以吸引更多伙伴的加入，将互联网精准扶贫模式贯彻到底。
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-item"
};
</script>

<style lang="scss" scoped>
</style>
